
export default {
  state() {
    return {

    }
  },

  getters: {
    get() {
      return null
    }
  },

  mutations: {

  },

  actions: {
    
  }
}